<template>
    <div class="smallView view" :class="{hasIcon: icon}" :style="{'backgroundImage': backgroundImg ? backgroundImg : '', 'backgroundColor': backgroundImg ? '#141722' : ''}">
        <div class="home">
            <div class="smallView__icon" v-if="icon">
                <img :src="'/static/svg/icons/'+icon+'.svg'" alt="">
            </div>
            <div class="smallView__country"><img :src="countryHome" :alt="countryHome"></div>
            <h2 class="smallView__title">
                <span class="smallView__title-number" v-html="titleHome.number"></span><br v-if="titleHome.hasBr">
                <span class="smallView__title-text" v-html="titleHome.text"></span>
            </h2>
            <p class="smallView__text" v-html="textHome"></p>
        </div>
        <div class="away">
            <div class="smallView__country"><img :src="countryAway" :alt="countryAway"></div>
            <h2 class="smallView__title">
                <span class="smallView__title-number" v-html="titleAway.number"></span><br v-if="titleAway.hasBr">
                <span class="smallView__title-text" v-html="titleAway.text"></span>
            </h2>
            <p class="smallView__text" v-html="textAway"></p>
        </div>
    </div>
</template>

<script>
    import icons from '@/assets/svg/icons'


    export default {
        name: 'SmallView',
        props: {
            backgroundImg: String,
            icon: String,
            countryHome: {
                type: String,
                required: true
            },
            countryAway: {
                type: String,
                required: true
            },
            titleHome: {
                type: Object,
                required: true
            },
            titleAway:  {
                type: Object,
                required: true
            },
            textHome: {
                type: String,
                required: true
            },
            textAway: {
                type: String,
                required: true
            },
        },
    }
</script>



// WEBPACK FOOTER //
// smallView.vue?bab82764